/**
 * Service type mappings for the new LineItem system
 * Used when enableRefactoredServices feature flag is enabled
 *
 * Maps old service type codes to new LineItem service type codes
 * and includes icon references for display
 */

export const lineItemServiceTypes = {
  // Accommodation/Hotel
  HTL: {
    code: 'HTL',
    oldCode: 'ACCO',
    name: 'Accommodation',
    iconref: 'Buildings'
  },
  // Transfer
  TRF: {
    code: 'TRF',
    oldCode: 'TRAN',
    name: 'Transfer',
    iconref: 'Path'
  },
  // Activity
  ACT: {
    code: 'ACT',
    oldCode: 'ACTV',
    name: 'Activity',
    iconref: 'PersonSimpleThrow'
  },
  // Flight
  FLT: {
    code: 'FLT',
    oldCode: 'FLTS',
    name: 'Flight',
    iconref: 'AirplaneTakeoff'
  },
  // Restaurant/Meal
  RST: {
    code: 'RST',
    oldCode: 'REST',
    name: 'Restaurant',
    iconref: 'ForkKnife'
  },
  // Car Rental
  CAR: {
    code: 'CAR',
    oldCode: 'CAR',
    name: 'Car',
    iconref: 'Car'
  },
  // Train
  TRN: {
    code: 'TRN',
    oldCode: 'TRN',
    name: 'Train',
    iconref: 'Train'
  },
  // Info
  INF: {
    code: 'INF',
    oldCode: null,
    name: 'Info',
    iconref: 'Info'
  }
};

/**
 * Get service type info by code
 * @param {string} code - The service type code (HTL, TRF, ACT, FLT, RST, CAR, TRN)
 * @returns {Object|null} Service type info or null if not found
 */
export const getLineItemServiceType = (code) => {
  if (!code) return null;
  const upperCode = code.toUpperCase();
  return (
    lineItemServiceTypes[
      /** @type {keyof typeof lineItemServiceTypes} */ (upperCode)
    ] || null
  );
};

/**
 * Get all service types as an array
 * @returns {Array<Object>} Array of service type objects
 */
export const getAllLineItemServiceTypes = () => {
  return Object.values(lineItemServiceTypes);
};
